import { BaseRouteRpc, RoleType } from '../../../../../core';
import { OrdersOrderFileGenerateDownloadLinkRequestSchema } from './request';
import { OrdersOrderFileGenerateDownloadLinkResponseSchema } from './response';
  
/**
* @description
*
*
* Request interface:
* ```
* export interface OrdersOrderFileGenerateDownloadLinkRequestSchema extends ContractData {
*     orderProductId:    number;
*     personalizationId: number;
* }
*
* ```
* Response interface:
*
* ```
* export interface OrdersOrderFileGenerateDownloadLinkResponseSchema extends ContractData {
*     link: string;
* }
*
* ```
*/
export class OrdersOrderFileGenerateDownloadLinkRouteRpc extends BaseRouteRpc {
  static method = 'orders-order-file-generate-download-link';

  static request: OrdersOrderFileGenerateDownloadLinkRequestSchema;
  static response: OrdersOrderFileGenerateDownloadLinkResponseSchema;

  static role = RoleType.user;
}
